import { FetchClient } from "../fetch-client"

export const GetItemById = async (itemId) => {
    return FetchClient(`/items?itemid=${itemId}`).GET({})
}

export const GetItemWithArtistByItemId = async (itemId) => {
    return FetchClient(`/item/user?itemid=${itemId}`).GET({})
}
